import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from "react-router-dom";

const GuardedRoute = ({ component: Component, auth, ...rest }) => (
    <Route {...rest} render={routeProps => {
        if (auth === true) {
            return <Component {...routeProps} />;
        }
        const attemptedUrl = routeProps.location.pathname + routeProps.location.search;
        // Only save the first attempted URL — multiple guarded routes can render
        // in the same unauthenticated pass, and re-writing on every render would
        // let the last one silently overwrite the user's original destination.
        if (attemptedUrl && attemptedUrl !== '/' && !sessionStorage.getItem('ddir_post_login_redirect')) {
            sessionStorage.setItem('ddir_post_login_redirect', attemptedUrl);
        }
        return <Redirect to='/' />;
    }} />
);

GuardedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  auth: PropTypes.bool
};

export default GuardedRoute;